import { render } from "./FailPage.vue?vue&type=template&id=a48aae92&scoped=true"
import script from "./FailPage.vue?vue&type=script&lang=js"
export * from "./FailPage.vue?vue&type=script&lang=js"

import "./FailPage.vue?vue&type=style&index=0&id=a48aae92&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48aae92"]])

export default __exports__